module.exports = __webpack_public_path__ + "img/s2on.266b5c46.svg";